import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class RedirectionService {
    public url: string = null;

    public constructor() {}

    public consume(): string {
        const url: string = this.url;
        this.url = null;
        return url;
    }
}
